import React, { FC, useState } from "react";
import { observer } from "mobx-react-lite";
import { makeStyles, Box, TextField } from "@material-ui/core";
import { Text } from "../components/Text";
import { store } from "../store";
import Button from "../components/Button";
import colors from "../constants/colors";
import { useIdentityContext } from "react-netlify-identity";
import { RouteComponentProps, withRouter } from "../utils/useRouter";

const Reset: FC<RouteComponentProps> = observer(({ history }) => {
  const classes = styles();
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState<string>("");
  const { user, updateUser } = useIdentityContext();
  const { password, inputEmail } = store;

  const handleUpdate = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    console.log(user);
    try {
      const response = await updateUser({
        email: inputEmail,
        password: password,
      });
      console.log("success", response);
      if (response) setSubmitted(true);
      setTimeout(() => {
        history.push("/");
      }, 3000);
    } catch (err) {
      console.log("error", err);
      setError(
        "There was an error changing your password, please try again later."
      );
    }
    return false;
  };

  return (
    <Box className={classes.container}>
      {!submitted ? (
        <form onSubmit={handleUpdate} className={classes.innerContainer}>
          <Box>
            <Text gutterBottom bold align="center">
              Choose a new password
            </Text>
          </Box>
          <Box className={classes.inputContainer}>
            <TextField
              InputProps={{ classes: { input: classes.input } }}
              placeholder="PASSWORD"
              className={classes.input}
              type="password"
              value={password}
              name="password"
              error={!!error}
              variant="filled"
              onChange={(e) =>
                (store[e.currentTarget.name] = e.currentTarget.value)
              }
            />
          </Box>
          {error && (
            <Box className={classes.errors}>
              <Text size="small" color="error" key={error}>
                {error}
              </Text>
            </Box>
          )}
          <Button type="submit">SUBMIT</Button>
        </form>
      ) : (
        <Box>
          <Text bold align="center">
            Success!
          </Text>
          <Text align="center">Your password has been changed.</Text>
          <Text align="center">Redirecting to home page in 3s.</Text>
        </Box>
      )}
    </Box>
  );
});

const styles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    padding: 30,
    minHeight: "100%",
    flex: 1,
    backgroundColor: colors.grey,
    borderRadius: 15,
    [theme.breakpoints.up("md")]: {
      borderRadius: 0,
      boxShadow: "0 50vh 0 50vh #F2F2F2",
      padding: 50,
      width: "100%",
    },
  },
  innerContainer: {
    [theme.breakpoints.up("md")]: {
      minWidth: 500,
      maxWidth: 600,
      margin: "0 auto",
    },
  },
  input: {
    width: "100%",
    background: "white",
  },
  inputContainer: {
    margin: "20px 0px",
  },
  message: {
    display: "flex",
    justifyContent: "center",
  },
  errors: {
    marginBottom: 20,
  },
}));

export default withRouter(Reset);
